import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "td-swipe pan-mb__guide-swiper" }
const _hoisted_2 = { class: "td-swipe-slides-wrap" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "banner-title" }
const _hoisted_5 = { class: "banner-desc" }
const _hoisted_6 = { class: "td-swipe-indicators" }
const _hoisted_7 = ["onClick"]

import { ref } from 'vue'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const carouselInstall = ref()
const currentIndex = ref(0)
const list = [
  {
    id: 0,
    img: require('@/assets/images/login/1.png'),
    title: '百兆极速传输',
    desc: '上传、下载不受限',
  },
  {
    id: 1,
    img: require('@/assets/images/login/2.png'),
    title: '沉浸影音体验',
    desc: '视频内容自动分类',
  },
  {
    id: 2,
    img: require('@/assets/images/login/3.png'),
    title: '文件安全备份',
    desc: '高效管理文件内容',
  },
]
const onChange = (index) => {
  currentIndex.value = index
}
const setActiveItem = (index) => {
  carouselInstall.value?.setActiveItem(index)
}

return (_ctx: any,_cache: any) => {
  const _component_el_carousel_item = _resolveComponent("el-carousel-item")!
  const _component_el_carousel = _resolveComponent("el-carousel")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_carousel, {
      height: "430px",
      arrow: "never",
      onChange: onChange,
      ref_key: "carouselInstall",
      ref: carouselInstall,
      trigger: "click"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(list, (item) => {
            return _createVNode(_component_el_carousel_item, {
              key: item.id
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", {
                  class: _normalizeClass(["td-slide", { 'is-active': item.id === currentIndex.value }])
                }, [
                  _createElementVNode("img", {
                    src: item.img,
                    alt: "item.title"
                  }, null, 8, _hoisted_3),
                  _createElementVNode("h4", _hoisted_4, _toDisplayString(item.title), 1),
                  _createElementVNode("p", _hoisted_5, _toDisplayString(item.desc), 1)
                ], 2)
              ]),
              _: 2
            }, 1024)
          }), 64))
        ])
      ]),
      _: 1
    }, 512),
    _createElementVNode("div", _hoisted_6, [
      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(list, (item) => {
        return _createElementVNode("div", {
          class: _normalizeClass(["td-swipe-indicator", { 'is-active': item.id === currentIndex.value }]),
          key: item.id,
          onClick: ($event: any) => (setActiveItem(item.id))
        }, null, 10, _hoisted_7)
      }), 64))
    ])
  ]))
}
}

})